module.exports = __webpack_public_path__ + "ColabReg.67e0292e6a679361981b.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/font/colaborate/ColabReg.woff
// module id = ../../../../../src/assets/font/colaborate/ColabReg.woff
// module chunks = 2